import React from 'react';
import moment from 'moment';
import CurrencyFormat from 'react-currency-format';
import { config } from '../../src/common/constant';
import { configureStore } from '../redux/configureStore';
import { CPF_NOMINATION, WASIAT, INSURANCE_NOMINATION } from './images-s3';
import JSZip from 'jszip';

export const Common = {
    getReadableDateFormat,
    navigateToLink,
    standardDateFormat,
    disableFutureDt,
    copyURL,
    isValidField,
    mobileFormatter,
    formatNumber,
    dateFormatterLeftBlock,
    muisDateFormatter,
    scrollToTop,
    resetData,
    generateToken,
    isValidUrl,
    intlNumberFormat,
    percentage,
    validateCreditCard,
    isMobile,
    trimExtraSpacesRemoveHTML,
    convertToNumber,
    setFavIconTitle,
    getZipFileName,
    convertFilesToZip,
    formatNumberNoRounding,
    getFormattedDate
};

function trimExtraSpacesRemoveHTML(input) {
    return String(input).trimStart().replace(config.REGEX.MULTIPLE_SPACES, ' ').replace(config.REGEX.HTML, '');
}

function isMobile() {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
}

function validateCreditCard(creditCardNumber) {
    // accept only digits, dashes or spaces
    if (/[^0-9-\s]+/.test(creditCardNumber)) return false;

    // The Luhn Algorithm. It's so pretty.
    let nCheck = 0;
    let nDigit = 0;
    let bEven = false;
    let strippedField = creditCardNumber.replace(/\D/g, "");

    for (let n = strippedField.length - 1; n >= 0; n--) {
        let cDigit = strippedField.charAt(n);
        nDigit = parseInt(cDigit, 10);

        if (bEven) {
            if ((nDigit *= 2) > 9) nDigit -= 9;
        }

        nCheck += nDigit;
        bEven = !bEven;
    }

    return (nCheck % 10) == 0;
}


function percentage(percent, total) {
    return Number(((percent / 100) * total).toFixed(2))
}

function intlNumberFormat(value, fracCount = 2) {
    return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: fracCount }).format(value)
}

function isValidUrl(string) {
    try { return Boolean(new URL(string)); }
    catch (e) { return false; }
}

function generateToken() {
    const head = Date.now().toString(36);
    const tail = Math.random().toString(36).substring(2);

    return (head + tail);
}

function resetData() {
    const { persistor } = configureStore();

    persistor.pause();
    persistor.purge();
}

function scrollToTop() {
    document.body.scrollTop = document.documentElement.scrollTop = 0;
}

function isValidField(value) {
    if (value === "" || value === null || value === 'null' || value === 'NA' || value === " " || value === undefined || value === "NULL"
    ) {
        return false
    } else {
        return true
    }
}

function getReadableDateFormat(value) {
    var given = moment("2021-06-28 17:00:00", "YYYY-MM-DD hh:mm:ss");
    var current = moment();
    var diff = moment.duration(given.diff(current));
}

function formatNumber(e) {

    const { currentTarget } = e;

    if (!/[0-9]/.test(e?.clipboardData?.getData('text/plain'))) {
        e.preventDefault();
    } else {
        var val = e?.clipboardData?.getData('text/plain').replace(/[^\d]/g, '').replace(/(.{4})/g, '$1 ').trim();
        setTimeout(() => {
            currentTarget.value = '';
            currentTarget.value = val;
        }, 10);
        // 2223003122003222
    }
}

function navigateToLink(navlink) {
    window.open(navlink, '_blank');
}

function standardDateFormat(cell) {
    if (!cell) { return ""; }
    if (typeof cell === 'string') {
        return `${moment(cell).format('D MMM YYYY')}`;
    }
}

function disableFutureDt(current) {
    const today = moment();
    return current.isBefore(today)
}

function copyURL() {
    const elem = document.createElement('input');
    elem.value = document.URL;
    // elem.hidden = true;
    document.body.appendChild(elem);
    elem.select();
    document.execCommand('copy');
    document.body.removeChild(elem);
}

function mobileFormatter(cell, row) {
    if (Common.isValidField(cell)) {
        return <CurrencyFormat displayType={'text'} format="+## #### ######" mask="" value={cell} />
    } else {
        return '-'; //<span className="d-block text-center no-value">-</span>
    }
}

function dateFormatterLeftBlock(cell) {
    if (!Common.isValidField(cell)) { return ""; }

    let dateTime;
    if (typeof cell === 'string') {
        dateTime = cell.trim().split(' ');
    }

    if (typeof cell === 'string' && dateTime.length > 1) {
        return `${moment(new Date(dateTime[0].replace(/-/g, "/"))).format(config.SAFARI_FORMAT.DATE)} | ${moment((dateTime[1] + ' ' + dateTime[2]), [config.SAFARI_FORMAT.TIME]).format(config.SAFARI_FORMAT.TIME)}`;// th, rd removed from all over places coming after Date number.
    } else {
        return `${moment(cell).format(config.SAFARI_FORMAT.DATE)}` + "  |  " + `${moment(cell).format(config.SAFARI_FORMAT.TIME)}`; // th, rd removed from all over places coming after Date number.
    }
    // return `${moment.utc(cell).tz("Asia/Singapore").format('Do MMM YYYY')}` + "  |  " + `${moment.utc(cell).tz("Asia/Singapore").format('h:mm A')}`;
}

function muisDateFormatter(cell) {
    if (!Common.isValidField(cell)) { return ""; }

    let dateTime;
    if (typeof cell === 'string') {
        dateTime = cell.trim().split(' ');
    }

    if (typeof cell === 'string' && dateTime.length > 1) {
        return `${moment(new Date(dateTime[0].replace(/-/g, "/"))).add(355, 'day').format(config.SAFARI_FORMAT.DATE)}`;// th, rd removed from all over places coming after Date number.
    } else {
        return `${moment(cell).format(config.SAFARI_FORMAT.DATE)}`;
    }

}
function setFavIconTitle(name) {
    let title, favicon, description, googleSiteVerification;
    switch (name) {
        case 'ZAKAT':
            title = 'Zakat Singapore | Muis';
            favicon = `/favicon.png?v=${Math.random()}`;
            description = 'A one-stop portal on Zakat Contributions, Fidyah & Kaffarah Payments online in Singapore.';
            break;
        case 'FIDYAH':
            title = 'Zakat Singapore | Muis';
            favicon = `/favicon.png?v=${Math.random()}`;
            description = 'A one-stop portal on Zakat Contributions, Fidyah & Kaffarah Payments online in Singapore.';
            break;
        case 'KAFFARAH':
            title = 'Zakat Singapore | Muis';
            favicon = `/favicon.png?v=${Math.random()}`;
            description = 'A one-stop portal on Zakat Contributions, Fidyah & Kaffarah Payments online in Singapore.';
            break;
        case 'ILMU':
            title = 'Wakaf Singapore | Muis';
            favicon = `/favicon-wakaf.png?v=${Math.random()}`;
            description = 'Wakaf is when you donate your assets as charity for pious and religious causes. The ownership of the asset that you donate is transferred to Allah s.w.t., and cannot be sold, given away or inherited by anyone until the end of time.';
            googleSiteVerification = 'cwCcqx23MnGbqMWQD35cUe78QjhRTZZ-jAYXN_jNOPU';
            break;
        case 'WMS':
            title = 'Wakaf Singapore | Muis';
            favicon = `/favicon-wakaf.png?v=${Math.random()}`;
            description = 'Wakaf is when you donate your assets as charity for pious and religious causes. The ownership of the asset that you donate is transferred to Allah s.w.t., and cannot be sold, given away or inherited by anyone until the end of time.';
            googleSiteVerification = 'cwCcqx23MnGbqMWQD35cUe78QjhRTZZ-jAYXN_jNOPU';
            break;
        default:
            title = 'Zakat Singapore | Muis';
            favicon = `/favicon.png?v=${Math.random()}`;
            description = 'A one-stop portal on Zakat Contributions, Fidyah & Kaffarah Payments online in Singapore.';
            break;
    }

    document.title = title;
    document.querySelector('meta[name="description"]').setAttribute("content", description);

    // if (name === 'ILMU' || name === 'WMS') {
    //     document.querySelector('meta[name="google-site-verification"]').setAttribute("content", googleSiteVerification);
    // }

    const favicons = [
        { rel: 'icon', type: 'image/png', sizes: '16x16', href: `${favicon}?v=${new Date().getTime()}` },
        { rel: 'icon', type: 'image/png', sizes: '32x32', href: `${favicon}?v=${new Date().getTime()}` },
        { rel: 'icon', type: 'image/png', sizes: '48x48', href: `${favicon}?v=${new Date().getTime()}` },
        { rel: 'shortcut icon', type: 'image/x-icon', href: `${favicon}?v=${new Date().getTime()}` },
        { rel: 'apple-touch-icon', type: 'image/png', sizes: '180x180', href: `${favicon}?v=${new Date().getTime()}` },
        { rel: 'mask-icon', type: 'image/png', href: `${favicon}?v=${new Date().getTime()}` },
    ];

    favicons.forEach((icon) => {
        let link = document.querySelector(`link[rel~='${icon.rel}']`);
        if (link) {
            document.head.removeChild(link);
        }
        link = document.createElement('link');
        link.rel = icon.rel;
        link.type = icon.type;
        link.href = icon.href;
        link.sizes = icon.sizes;
        document.head.appendChild(link);
    });
}

// function setFavIconTitle (name) {
//     let title, favicon, description;
//     switch (name) {
//       case 'ZAKAT':
//         title = 'Zakat Singapore | Muis';
//         favicon = `/favicon.png?v=${Math.random()}`;
//         description = 'A one-stop portal on Zakat Contributions, Fidyah & Kaffarah Payments online in Singapore.';
//         break;
//       case 'FIDYAH':
//         title = 'Zakat Singapore | Muis';
//         favicon = `/favicon.png?v=${Math.random()}`;
//         description = 'A one-stop portal on Zakat Contributions, Fidyah & Kaffarah Payments online in Singapore.';
//         break;
//       case 'KAFFARAH':
//         title = 'Zakat Singapore | Muis';
//         favicon = `/favicon.png?v=${Math.random()}`;
//         description = 'A one-stop portal on Zakat Contributions, Fidyah & Kaffarah Payments online in Singapore.';
//         break;
//       case 'ILMU':
//         title = 'Wakaf Singapore | Muis';
//         favicon = `/favicon-wakaf.png?v=${Math.random()}`;
//         description = 'Wakaf is when you donate your assets as charity for pious and religious causes. The ownership of the asset that you donate is transferred to Allah s.w.t., and cannot be sold, given away or inherited by anyone until the end of time.';
//         break;
//       case 'WMS':
//         title = 'Wakaf Singapore | Muis';
//         favicon = `/favicon-wakaf.png?v=${Math.random()}`;
//         description = 'Wakaf is when you donate your assets as charity for pious and religious causes. The ownership of the asset that you donate is transferred to Allah s.w.t., and cannot be sold, given away or inherited by anyone until the end of time.';
//         break;
//       default:
//         title = 'ZAKAT';
//         favicon = `/favicon.png?v=${Math.random()}`;
//         description = 'A one-stop portal on Zakat Contributions, Fidyah & Kaffarah Payments online in Singapore.';
//         break;
//     }

//     document.title = title;
//      const link = document.querySelector("link[rel='shortcut icon']");
//      console.log(link, 'Linkkks')
//      link.href = favicon;
//     // const link = document.createElement("link");
//     // link.rel = "shortcut icon";
//     // link.type = "image/png";
//     link.href = favicon;
//     document.head.appendChild(link);
//     document.getElementsByTagName('head')[0].appendChild(link);
//     console.log(link, 'newLink')
//     // Update meta description
//     let metaDescription = document.querySelector("meta[name='description']");
//     if (!metaDescription) {
//         metaDescription = document.createElement('meta');
//         metaDescription.name = 'description';
//         document.head.appendChild(metaDescription);
//     }
//     metaDescription.content = description;
//   }


function convertToNumber(amount) {
    if (typeof amount === 'string') {
        // Remove any non-numeric characters except the decimal point
        const numberString = amount.replace(/[^0-9.-]+/g, '');
        return parseFloat(numberString);
    }
    return amount; // If it's already a number, return it as is
};

/*
    Return Zip file Name based on passed parameters
    @params
        namePrefix: String - prefix for the file name 
        receipt: String - Receipt Number
        receiptDate: String - Transaction DateTime   
    @returns 
        String - Zip File Name
*/
function getZipFileName(namePrefix, receipt, receiptDate) {
    const FORMAT = "DD MMM YYYY hh:mm A"; // Preformatted date from BE
    const NAME_DATE_FORMAT = 'DDMMYYYY'; // Date Format in Zip File Name

    const date = moment(receiptDate, FORMAT).format(NAME_DATE_FORMAT);
    return `${namePrefix}_${receipt}_${date}_${Date.now()}.zip`
}

// creates and return the zip of the passed files
async function convertFilesToZip(filesArray = []) {
    if (!filesArray.length) return false;

    const zip = new JSZip();

    const readFileAsArrayBuffer = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = (event) => resolve(event.target.result);
            reader.onerror = (error) => reject(error);
            reader.readAsArrayBuffer(file);
        });
    };

    try {
        for (const file of filesArray) {
            // Check if the object is already a File or Blob
            let actualFile;
            if (file instanceof File || file instanceof Blob) {
                actualFile = file;
            } else {
                // Convert plain object to File
                actualFile = new File([file], file.name, {
                    type: file.type || 'application/octet-stream',
                    lastModified: file.lastModified || Date.now(),
                });
            }

            const arrayBuffer = await readFileAsArrayBuffer(actualFile);
            zip.file(actualFile.name, arrayBuffer);
        }

        return zip.generateAsync({ type: "blob" });
    } catch (error) {
        console.error('Error while converting files to zip:', error);
        return false;
    }
}

export const policyTypes = {
    "1": "Whole Life",
    "2": "Term Life",
    "3": "Endowment",
    "4": "Investment-Linked Plan",
    "5": "Others"
};

export const SINGAPORE_TIMEZONE = "Asia/Singapore"

export const pledgingCard = [
    {
        name: 'Wasiat',
        id: 1,
        img: WASIAT,
        route: '/pledging/wasiat'
    },
    {
        name: 'CPF Nomination',
        id: 2,
        img: CPF_NOMINATION,
        route: '/pledging/cpf'
    },
    {
        name: 'Insurance Nomination',
        id: 3,
        img: INSURANCE_NOMINATION,
        route: '/pledging/insurance'
    }
]

function formatNumberNoRounding(value, decimals) {
    const str = value.toString();
    const decimalIndex = str.indexOf('.');
    if (decimalIndex === -1) {
        return str + '.' + '0'.repeat(decimals);
    }

    const decimalsCount = str.length - decimalIndex - 1;
    if (decimalsCount === decimals) {
        return str;
    }

    if (decimalsCount > decimals) {
        return str.slice(0, decimalIndex + decimals + 1);
    }

    return str + '0'.repeat(decimals - decimalsCount);
}

function getFormattedDate(date, yearFirst = false) {
    const dateObj = new Date(date); // Convert to Date object
    const year = dateObj.getFullYear();
    const month = String(dateObj.getMonth() + 1).padStart(2, '0'); // Months are 0-based, so add 1
    const day = String(dateObj.getDate()).padStart(2, '0');
    if(yearFirst) {
        return `${year}-${month}-${day}`;
    } else {
        return `${day}-${month}-${year}`;
    } // Return date in YYYY-MM-DD format
}

export const formatResponse = (responseTextValue) => {
    if (!responseTextValue || typeof responseTextValue !== 'string') return "";
    
    // First, normalize line endings to prevent Safari issues
    let formattedText = responseTextValue.replace(/\r\n?/g, '\n');
    
    // Decode HTML entities - more comprehensive approach
    const entityMap = {
        '&amp;': '&',
        '&lt;': '<',
        '&gt;': '>',
        '&quot;': '"',
        '&#39;': "'",
        '&nbsp;': ' '
    };
    
    formattedText = formattedText.replace(/&(amp|lt|gt|quot|#39|nbsp);/g, match => entityMap[match]);
    
    // Convert **bold** text - with Safari workaround
    formattedText = formattedText.replace(/\*\*([^*]+)\*\*/g, '<b>$1</b>');
    
    // Convert ### headings - more reliable pattern
    formattedText = formattedText.replace(/^###\s+([^\n]+)/gm, '<h3>$1</h3>');
    
    // Convert LaTeX expressions - with Safari-compatible approach
    formattedText = formattedText.replace(/\\\[([^\\]+)\\\]/g, 
        '<div class="math-display">$$$1$$</div><span class="math-fallback">$1</span>');
    
    // formattedText = formattedText.replace(/\\\(([^\\]+)\\\)/g, 
    //     '<span class="math-inline">$$$1$</span><span class="math-fallback">$1</span>');

    // Inline math
    formattedText = formattedText.replace(/\\\((.+?)\\\)/gs, (_, content) =>
    `<span class="math-inline">\\(${content}\\)</span>`
    );
    
    // Convert tables before line breaks
    formattedText = convertMarkdownTableToHtml(formattedText);
    
    // Convert line breaks - handle multiple cases
    formattedText = formattedText.replace(/\n{2,}/g, '<br><br>');
    formattedText = formattedText.replace(/\n/g, '<br>');
    
    // Final cleanup for Safari quirks
    formattedText = formattedText.replace(/<br><\/td>/g, '</td>');
    formattedText = formattedText.replace(/<br><\/th>/g, '</th>');

     // 🔐 Apply final sanitization here
    formattedText = sanitizeFormattedResponse(formattedText);
    
    return `<div class="assistant-response">${formattedText}</div>`;
};

export const sanitizeFormattedResponse = (htmlText) => {
  if (!htmlText || typeof htmlText !== 'string') return "";

  let cleanedText = htmlText;

  // Remove stray slashes `/` not part of a tag or math block
  cleanedText = cleanedText.replace(/(?<!<[^>]*)\/(?![^<]*>)/g, '');

  // ⚠️ Do NOT globally remove backslashes
  // Optionally remove backslashes NOT inside LaTeX blocks
  // Keep LaTeX expressions like \text{grams}
  // No change here unless you have a strong need

  // Clean up zero-width spaces or non-visible chars
  cleanedText = cleanedText.replace(/\u200B/g, '');

  return cleanedText;
};

export const convertMarkdownTableToHtml = (markdownText) => {
    // More reliable table pattern that works in Safari
    const tablePattern = /((?:^|\n)\|?.+?\|\r?\n\|?.+?\|\r?\n(?:(?:\|?.+?\|\r?\n?)+)?)/g;
    
    return markdownText.replace(tablePattern, (fullMatch) => {
        const rows = fullMatch.trim().split('\n').filter(row => row.trim());
        if (rows.length < 2) return fullMatch; // Not a valid table
        
        const headers = rows[0].split('|').map(h => h.trim()).filter(h => h);
        const alignments = rows[1].split('|').map(a => a.trim().replace(/-+/g, ''));
        
        // Validate table structure
        if (headers.length === 0 || headers.length !== alignments.length) {
            return fullMatch;
        }
        
        let html = '<table border="1" cellspacing="0" cellpadding="5">';
        html += '<thead><tr>';
        
        // Add headers
        headers.forEach(header => {
            html += `<th>${header}</th>`;
        });
        html += '</tr></thead><tbody>';
        
        // Add data rows
        for (let i = 2; i < rows.length; i++) {
            const cells = rows[i].split('|').map(c => c.trim());
            if (cells.length <= 1) continue;
            
            html += '<tr>';
            headers.forEach((_, j) => {
                html += `<td>${cells[j] || ''}</td>`;
            });
            html += '</tr>';
        }
        
        html += '</tbody></table>';
        return html;
    });
};

export function extractZakatAmount(text) {
    const lines = Array.isArray(text) ? text : text.split('\n');
    // Target phrases to look for
    const targetPhrases = [
        'total zakat payable',
        'total amount zakat payable',
        'total amount of zakat payable',
        "Jumlah Zakat Payable"
    ];
    const summaryStartIndex = lines.findIndex(line =>
        line.toLowerCase().trim().includes('zakat calculation summary') ||
        line.toLowerCase().trim().includes('ringkasan kiraan zakat')
    );

    if (summaryStartIndex === -1) return null;
    
    const summaryLines = lines.slice(summaryStartIndex + 1);
    
    const zakatLine = summaryLines.find(line => {
        const lowerLine = line.toLowerCase().trim();
        return targetPhrases.some(phrase => lowerLine.includes(phrase));
    });

    if (!zakatLine) return null;

    let amountPart = zakatLine;
    const separators = [':', '='];
    
    let lastSeparatorIndex = -1;
    let lastSeparator = null;
    for (const sep of separators) {
        const index = zakatLine.lastIndexOf(sep);
        if (index > lastSeparatorIndex) {
            lastSeparatorIndex = index;
            lastSeparator = sep;
        }
    }
    
    if (lastSeparator !== null) {
        amountPart = zakatLine.slice(lastSeparatorIndex + 1).trim();
    }
    
    amountPart = amountPart.replace(/SGD/gi, '').trim();
    
    let numericStr = '';
    let hasDecimal = false;
    
    for (let i = 0; i < amountPart.length; i++) {
        const char = amountPart[i];
        
        if (char >= '0' && char <= '9') {
            numericStr += char;
        } else if (char === '.' && !hasDecimal) {
            numericStr += char;
            hasDecimal = true;
        } else if (char === ',') {
            continue;
        } else if (numericStr.length > 0) {
            break;
        }
    }    
    const amount = parseFloat(numericStr);
    return isNaN(amount) ? null : amount;
}

export const extractZakatData = (botResponse, type) => {
    if (!botResponse || typeof botResponse !== "string") return null;
  
    const cleanedText = botResponse.replace(/<[^>]*>/g, "").trim();
  
    // Business logic
    if (type?.toLowerCase() === 'business') {
      const totalAmount = extractZakatAmount(cleanedText);
      return {
        Business: { name: "Business", amount: totalAmount || 0 },
        totalAmount: totalAmount || 0
      };
    }
  
    // Initialize result for individual
    const result = {
      savings: { name: "Savings", amount: 0 },
      gold: { name: "Gold", amount: 0 },
      insurance: { name: "Insurance", amount: 0 },
      shares: { name: "Shares", amount: 0 },
      totalAmount: 0
    };
  
    // Extract the summary section
    const summarySectionMatch = cleanedText.match(/(?:\*\*)?\s*(Zakat Calculation Summary|Ringkasan Kiraan Zakat):?(?:\*\*)?\s*\n?([\s\S]*?)(?=Total Zakatable Wealth|Jumlah Aset Zakatable)/i);
    const summarySection = summarySectionMatch?.[2]?.trim() || "";
    console.log(summarySection,'summarySection')
    if (!summarySection) {
      result.totalAmount = extractZakatAmount(cleanedText);
      return result;
    }
  
    // Define regex map
    const regexMap = {
        savings: /(?:\*\*)?\s*(Savings|Simpanan)\s*\(2\.5%\)(?:\*\*)?:?\s*SGD\s*([\d,]+(?:\.\d{1,2})?)/i,
        gold: /(?:\*\*)?\s*(Gold|Emas)\s*\(2\.5%\)(?:\*\*)?:?\s*SGD\s*([\d,]+(?:\.\d{1,2})?)/i,
        insurance: /(?:\*\*)?\s*(Insurance|Insurans)\s*\(2\.5%\)(?:\*\*)?:?\s*SGD\s*([\d,]+(?:\.\d{1,2})?)/i,
        shares: /(?:\*\*)?\s*(Shares|Saham)\s*\(2\.5%\)(?:\*\*)?:?\s*SGD\s*([\d,]+(?:\.\d{1,2})?)/i
    };
  
    // Extract each value
    Object.entries(regexMap).forEach(([key, regex]) => {
      const match = summarySection.match(regex);
      if (match) {
           result[key] = {
              name: key.charAt(0).toUpperCase() + key.slice(1),
              amount: parseFloat(match[2].replace(/,/g, '')) || 0
          };
      }
    });
  
    // Set total amount
    result.totalAmount = extractZakatAmount(cleanedText) || 0;
    console.log(result,'result')
    return result;
  };